import Drawer from '@material-ui/core/Drawer';
import React, {useState} from 'react';

import {useHandleScroll} from '../../../../pages/HomePage/HomePageSidebar/useHandleScroll';
import {ResizableDrawer} from '../ResizableDrawer';
import {CreateRegistryDrawerInner} from './CreateRegistryDrawerInner';

type CreateRegistryDrawerProps = {
  open: boolean;
  closeDrawer: () => void;

  entityName: string;
  existingRegistryNames: Set<string>;
  organizationId?: string;
  organizationName: string;
};

export const CreateRegistryDrawer = ({
  open,
  closeDrawer,
  entityName,
  existingRegistryNames,
  organizationName,
  organizationId,
}: CreateRegistryDrawerProps) => {
  const [width, setWidth] = useState(600); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  const scrolled = useHandleScroll();
  return (
    <Drawer anchor="right" open={open} onClose={closeDrawer}>
      <ResizableDrawer
        startWidth={width}
        minWidth={600}
        onSetWidth={onSetWidth}>
        <CreateRegistryDrawerInner
          scrolled={scrolled}
          closeDrawer={closeDrawer}
          entityName={entityName}
          existingRegistryNames={existingRegistryNames}
          organizationName={organizationName}
          organizationId={organizationId}
        />
      </ResizableDrawer>
    </Drawer>
  );
};
